import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { z } from 'zod';

const countrySchema = z.enum(['US', 'GB', 'IE']);
export type TestCallIntent = {
  phoneNumber: string;
  country: z.infer<typeof countrySchema>;
};
const bodySchema = z
  .object({
    phone: z.string(),
    country: countrySchema,
    requestId: z.string().uuid(),
  })
  .strict();

export function buildTestCallPayload(input: TestCallIntent, requestId: string) {
  const phone = parsePhoneNumberFromString(
    input.phoneNumber.trim().replace(/^00/, '+'),
    { defaultCountry: input.country, extract: false }
  );
  if (
    !phone?.isValid() ||
    phone.ext ||
    !countrySchema.safeParse(phone.country).success
  )
    throw new Error('Enter a valid UK, US or Irish phone number.');
  return bodySchema.parse({
    phone: phone.number,
    country: phone.country,
    requestId,
  });
}
